const cyrillicToLatin: Record<string, string> = {
  А: "A", а: "a", Б: "B", б: "b", В: "V", в: "v", Г: "G", г: "g", Ґ: "G", ґ: "g",
  Д: "D", д: "d", Е: "E", е: "e", Ё: "Yo", ё: "yo", Є: "Ye", є: "ie", Ж: "Zh", ж: "zh",
  З: "Z", з: "z", И: "I", и: "i", І: "I", і: "i", Ї: "Yi", ї: "i", Й: "Y", й: "y",
  К: "K", к: "k", Л: "L", л: "l", М: "M", м: "m", Н: "N", н: "n", О: "O", о: "o",
  П: "P", п: "p", Р: "R", р: "r", С: "S", с: "s", Т: "T", т: "t", У: "U", у: "u",
  Ў: "U", ў: "u", Ф: "F", ф: "f", Х: "Kh", х: "kh", Ц: "Ts", ц: "ts", Ч: "Ch", ч: "ch",
  Ш: "Sh", ш: "sh", Щ: "Shch", щ: "shch", Ъ: "", ъ: "", Ы: "Y", ы: "y", Ь: "", ь: "",
  Э: "E", э: "e", Ю: "Yu", ю: "yu", Я: "Ya", я: "ya",
};

/** Keeps cached source data intact while presenting Cyrillic personal names in Latin script. */
export function displayPersonName(value: string) {
  if (!/[\u0400-\u052f]/u.test(value)) return value;
  return [...value].map((character) => cyrillicToLatin[character] ?? character).join("");
}
